@if (!hidePage()) {
  <footer class="relative z-20 w-full" [ngClass]="{ 'bg-[#152138]': darkbackground() }">
    <div class="container mx-auto px-6 md:px-8 py-6 md:py-8">
      <div class="flex flex-col md:flex-row justify-between items-center gap-4">
        <!-- Logo -->
        <div class="flex items-center">
          @if (darkbackground()) {
            <img src="assets/images/joiistudies-white.png" alt="Joii Studies" class="h-10 w-auto object-scale-down" />
          } @else {
            <img src="assets/images/joiistudies-orange.png" alt="Joii Studies" class="h-10 w-auto object-scale-down" />
          }
        </div>

        <!-- Links -->
        <div
          class="flex flex-col md:flex-row gap-3 md:gap-6 text-#070b12 text-sm font-medium text-center md:text-left"
          [ngClass]="{ 'text-white': darkbackground() }"
        >
          <a
            joii-link
            role="button"
            tabindex="0"
            (click)="logclick('Privacy Policy')"
            (keydown.enter)="logclick('Privacy Policy')"
            [color]="darkbackground() ? 'white' : 'default'"
            >Privacy Policy</a
          >
          <a
            joii-link
            role="button"
            tabindex="0"
            (click)="logclick('Terms of Use')"
            (keydown.enter)="logclick('Terms of Use')"
            [color]="darkbackground() ? 'white' : 'default'"
            >Terms of Use</a
          >
          <a joii-link [href]="supportMailto" [color]="darkbackground() ? 'white' : 'default'">Contact Support</a>
        </div>
      </div>
    </div>
  </footer>
}
